// Golden "Unaffiliated" badge — same size/shape as the existing exchange
// badges on the Creator Grid rows and profile header. Amber-500 with an
// amber-400 ring, following the shadcn/Tailwind palette already used
// elsewhere in the app.
export function UnaffiliatedBadge({ compact = false, className = "" }) {
  const base = compact
    ? "inline-flex items-center gap-1 px-1.5 py-0.5 text-[10px] leading-none rounded font-medium"
    : "inline-flex items-center gap-1 px-2 py-0.5 text-[11px] leading-none rounded font-medium";
  return (
    <span
      data-testid="unaffiliated-badge"
      className={`${base} bg-amber-500/15 text-amber-300 ring-1 ring-inset ring-amber-400/60 ${className}`}
      title="Unaffiliated · promotes no exchange / broker / platform"
    >
      <span className="w-1.5 h-1.5 rounded-full bg-amber-400 shadow-[0_0_6px_rgba(251,191,36,0.9)]" />
      Unaffiliated
    </span>
  );
}

export default UnaffiliatedBadge;
